import { useEffect, useState } from "react";
import { resolveImageUrl } from "../imageUrl";

const ArticleImage = ({ src, name }) => {
    const imageUrl = resolveImageUrl(src);
    const [failed, setFailed] = useState(!imageUrl);

    useEffect(() => {
        setFailed(!imageUrl);
    }, [imageUrl]);

    if (failed || !imageUrl) {
        return (
            <div className="article-placeholder" aria-hidden="true">
                {name?.charAt(0)?.toUpperCase() || "?"}
            </div>
        );
    }

    return (
        <img
            src={imageUrl}
            alt={name}
            loading="lazy"
            onError={() => setFailed(true)}
        />
    );
};

export default ArticleImage;
